import { getProductCollectionV2WithSubCategoriesOption } from "@gtsanders/Services/ProductServiceV2";
import isApiError from "@insite/client-framework/Common/isApiError";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getAlsoPurchasedProductsCollectionV2, getRelatedProductsCollectionV2, ProductExpandTokens } from "@insite/client-framework/Services/ProductServiceV2";
import { StorefrontAccess } from "@insite/client-framework/Services/SettingsService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";

replaceInChain(chain, RequestDataFromApi, async (props) => {
    const state = props.getState();
    const currentPage = getCurrentPage(state);
    const { storefrontAccess } = getSettingsCollection(state).productSettings;
    if (
        storefrontAccess === StorefrontAccess.SignInRequiredToBrowse &&
        !state.context.session.isAuthenticated &&
        (currentPage.fields.excludeFromSignInRequired || currentPage.type === "SignInPage")
    ) {
        return false;
    }

    try {
        if ("relationship" in props.apiParameter) {
            props.apiResult = await getRelatedProductsCollectionV2(props.apiParameter);
        } else if ("productId" in props.apiParameter && props.apiParameter?.type === "alsoPurchased") {
            props.apiResult = await getAlsoPurchasedProductsCollectionV2(props.apiParameter);
        } else {
            const expandForCollection: ProductExpandTokens = [
                "detail"
            ];
            const finalApiParameter = {
                ...props.apiParameter,
                expand: props.apiParameter.expand ? [...props.apiParameter.expand, ...expandForCollection] : expandForCollection,
            }
            props.apiResult = await getProductCollectionV2WithSubCategoriesOption(finalApiParameter);
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }

        if (storefrontAccess === StorefrontAccess.SignInRequiredToBrowse && error.status === 403) {
            // auth timed out with SignInRequiredToBrowsee - throw this up as a 401 so DisplayError reloads the site
            error.status = 401;
            error.errorJson = { message: "error" };
        }

        throw error;
    }
});